import * as fromDatatype from '../datatype-library/index';

export interface app_mst_custom_field_association_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  cf_item_guid: fromDatatype.GuidDataFieldInterface;
  ref_type: fromDatatype.VarcharDatatypeInterface;
  ref_table: fromDatatype.TextDatatypeInterface;
  ref_column: fromDatatype.VarcharDatatypeInterface;
  ref_row: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class app_mst_custom_field_association_RowClass implements app_mst_custom_field_association_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  cf_item_guid: fromDatatype.GuidDataFieldInterface;
  ref_type: fromDatatype.VarcharDatatypeInterface;
  ref_table: fromDatatype.TextDatatypeInterface;
  ref_column: fromDatatype.VarcharDatatypeInterface;
  ref_row: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}


